<template>
<!-- deactivate -->
  <div class="modal fade" id="deactivateAccount" tabindex="-1" aria-labelledby="deactivateAccountTitle" style="display: none;" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-md two-factor-auth-sms">
      <div class="modal-content">
        <div class="modal-header bg-transparent">
          <button id="deactivateAccountClose" type="button" class="btn-close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
        </div>
        <div class="modal-body pb-5 px-sm-5 mx-50">
          <h4 >Deactivate Account</h4>
          <div class="col-md-12">
            <div class="form-group">
              <label for="reasonfordeactivate">Reason For Deactivate</label>
              <input type="text" class="form-control" placeholder="Reason For Deactivate" name="reasonfordeactivate" id="reasonfordeactivate" v-model="reasonfordeactivate">
            </div>
          </div>
          <div class="col-12 d-flex flex-sm-row flex-column mt-2">
            <button type="submit" class="btn btn-primary mb-1 mb-sm-0 mr-0 mr-sm-1" v-on:click="deactivateAccount">Deactivate Account</button>
            <button id="deactivateAccountClose" type="button" class="btn btn-outline-warning waves-effect" data-dismiss="modal" aria-label="Close">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </div>
<!-- end deactivate -->
</template>
<script>
import { useUserStore } from '../../../../stores/UserStore';
import { ref } from 'vue'
export default {
    setup(){
        const reasonfordeactivate = ref();
        return{
            userStore:useUserStore(),
            reasonfordeactivate
        }
    },
    methods: {
        deactivateAccount(){
            if(this.reasonfordeactivate ==""){
                toastr.error('field can not be empty','error');
            }else{
            let params ={
                'deactivate-reason':this.reasonfordeactivate,
            }
            axios.post(`/account/deactivate/${this.userStore.deactivateId}`,params).then(({data})=>{
                toastr.success(data.message,'success');
                this.reasonfordeactivate ="";
                if(data.error != true){
                    setTimeout(()=>{
                        window.location.href=data.data
                    },3000);
                }
                
            }).catch(error=>{
                toastr.error('An error occured please try again or contact support.','error');
            });
            }
        },
    },
}
</script>